import React from 'react';
import { BiPhone } from 'react-icons/bi';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';
import Utilities from '@/utils';

import { IAiAppearance } from '../types';
import BiLouiseSmallGray from './icons/BiLouiseSmallGray';
import { widgetUtils } from './utils';

const CallBot = ({ data: appearance }: { data: IAiAppearance }) => {
  const themeBg = appearance.theme === 'light' ? 'tw-bg-gray-50 tw-text-gray-700' : 'tw-bg-gradient-to-r tw-from-gray-900 tw-via-gray-800 tw-to-gray-900';
  const themeBorderColor = appearance.theme === 'light' ? 'tw-border-gray-400' : 'tw-border-gray-600/50';

  return (
    <div id="widget" className={`tw-flex tw-relative`}>
      {appearance?.customCss && <style dangerouslySetInnerHTML={{ __html: Utilities.makeAllCssImportant(appearance.customCss) }} />}

      <div className={`tw-flex tw-flex-col ${appearance.position === 'left' ? 'tw-items-end' : 'tw-items-start'}`}>
        <div
          className={`cs_bot_body cs_bot_container tw-w-[210px] tw-h-[60px] tw-rounded-full tw-p-1 tw-border tw-border-solid ${themeBorderColor} tw-relative tw-overflow-hidden ${themeBg}`}
        >
          <div
            className={`tw-relative tw-flex tw-items-center tw-h-full tw-gap-2 tw-px-3 ${
              appearance.position === 'left' ? 'tw-flex-row-reverse' : 'tw-flex-row'
            }`}
          >
            <div className="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-min-w-0">
              <div className="tw-flex-1 tw-text-center">
                <span
                  className={`tw-text-gray-300 tw-text-sm cs_bot_message_text`}
                  style={{
                    color: widgetUtils.bgColorMapper[appearance?.color] ?? appearance?.color,
                  }}
                >
                  {appearance?.notificationMessage && appearance?.isNotificationMessageActive ? appearance?.notificationMessage : 'Start a conversation'}
                </span>
              </div>
            </div>

            <div className="tw-flex tw-gap-1">
              <button
                id="btn-call-bot"
                disabled
                onClick={() => undefined}
                className={`tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-full tw-transition-all tw-duration-300 tw-transform tw-hover:scale-105 tw-active:scale-95
              tw-bg-gradient-to-r tw-from-green-500 tw-to-green-600 tw-hover:from-green-600 tw-hover:to-green-700 tw-text-white tw-shadow-lg tw-shadow-green-500/25 cs_bot_voice_btn`}
              >
                <BiPhone size={16} />
              </button>
            </div>
          </div>
        </div>
        {/* Footer */}
        <div className={`tw-pb-3 tw-px-4`}>
          {(appearance.poweredBy || appearance.customPoweredBy?.isActive) && (
            <div className={`tw-h-5 tw-mt-2 tw-text-[#9CA3AF] tw-items-center tw-gap-0.5 tw-flex tw-justify-center tw-text-center`}>
              <div className="tw-text-[10px] tw-font-normal tw-font-['Lexend'] tw-leading-[15px]">Powered by</div>
              {appearance.customPoweredBy?.isActive && (
                <React.Fragment>
                  {appearance.customPoweredBy?.config?.companyLogo &&
                    (appearance.customPoweredBy?.config?.companyUrl?.startsWith('https://') ? (
                      <a href={`${appearance.customPoweredBy?.config?.companyUrl}`} target="_blank" rel="noreferrer">
                        <img
                          src={appearance.customPoweredBy?.config?.companyLogo}
                          width={14}
                          height={14}
                          alt={appearance.customPoweredBy?.config?.companyName}
                          className="tw-object-contain"
                        />
                      </a>
                    ) : (
                      <img
                        src={appearance.customPoweredBy?.config?.companyLogo}
                        width={14}
                        height={14}
                        alt={appearance.customPoweredBy?.config?.companyName}
                        className="tw-object-contain"
                      />
                    ))}
                  {appearance.customPoweredBy?.config?.companyName &&
                    (appearance.customPoweredBy?.config?.companyUrl?.startsWith('https://') ? (
                      <a href={`${appearance.customPoweredBy?.config?.companyUrl}`} target="_blank" rel="noreferrer">
                        <span className="tw-font-bold tw-text-[10px] tw-font-['Lexend'] tw-flex tw-items-center">
                          {appearance.customPoweredBy?.config?.companyName}
                        </span>
                      </a>
                    ) : (
                      <span className="tw-font-bold tw-text-[10px] tw-font-['Lexend']">{appearance.customPoweredBy?.config?.companyName}</span>
                    ))}
                </React.Fragment>
              )}
              {appearance.poweredBy && (
                <a
                  href="https://louisebot.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-text-center tw-flex tw-items-center tw-justify-center tw-gap-1"
                >
                  <div className="tw-justify-start tw-items-center tw-gap-0.5 tw-flex">
                    <BiLouiseSmallGray fill={'#9CA3AF'} />
                  </div>
                  <div className="tw-font-bold tw-text-[10px] tw-font-['Lexend']">LouiseBot</div>
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WrappedErrorBoundary(CallBot);
